module.exports = "<ion-view class=\"forbid-view\">\r\n  <ion-content>\r\n    <div class=\"m-common-content\">\r\n      <p class=\"common-title\" ng-if=\"reason === 'license_expired'\">{{ 'LICENSE_INVALID_TIP' | translate }}</p>\r\n      <p class=\"common-title\" ng-if=\"!reason\">{{ 'TIPS.FORBIDDEN' | translate }}</p>\r\n    </div>\r\n  </ion-content>\r\n</ion-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/common/forbid.html
// module id = nt8X
// module chunks = 1